import React, { Component } from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from "./Pages/home";
import Gallery from "./Pages/gallery";
 
function App() {

	return (
		<div>
			<BrowserRouter>
				<Routes>

					<Route path='/' element={<Home />} />
					<Route path='gallery' element={<Gallery />} />
 
				</Routes>
			</BrowserRouter>
			<div>
			</div>
		</div>
	)
}


export default App;
